import { SelectedScheduleMap, SelectedScheduleRouteRoutine } from '../../../../types/MachineDetailsRobotSchedule.types';
import { CleaningScheduleCardB50 } from './CleaningScheduleCardB50';
import { CleaningScheduleCardCV50 } from './CleaningScheduleCardCV50';

interface CleaningScheduleCardProps {
  isB50: boolean;
  selectedSchedule: SelectedScheduleRouteRoutine | SelectedScheduleMap;
  onEdit: () => void;
}

export const CleaningScheduleCard = ({ isB50, selectedSchedule, onEdit }: CleaningScheduleCardProps): JSX.Element => {
  if (isB50) {
    return (
      <CleaningScheduleCardB50
        selectedRouteRoutine={selectedSchedule as SelectedScheduleRouteRoutine}
        onEdit={onEdit}
      />
    );
  }

  return <CleaningScheduleCardCV50 selectedScheduleMap={selectedSchedule as SelectedScheduleMap} onEdit={onEdit} />;
};
